import React, { useState, useEffect } from "react";
import styled from "styled-components";
import background from "../../assets/background.png";
import MTCGameLimited from "../../components/MTCGameLimited";
import MTCCalculator from "../../components/MTCCalculator";
import { Button } from "../../../../globals/components/button";
import { navigate } from "@reach/router";
import axios from "axios";
import useAuth from "../../../auth/hooks/useAuth";

import Calculator from "../../components/CalculatorNumberBonds";

//issue: find out why props.questionsCount doesnt update

//GLOBALS
var generatedQuestions = false;
var qNum = 0;
var qCount = 20;
var questionMode = true;
var modeText = "ANSWER";
//

//DEBUG STUFF

function Skip() {
  qNum = 24;
}
//DEBUG STUFF

function GenerateRandom(min, max) {
  return Math.floor(Math.random() * (max - min) + min);
}

function GenerateRandomUnique(min, max, list) {
  let num = Math.floor(Math.random() * (max - min) + min);
  let notUsed = true;
  for (let i = 0; i < list.length; i++) {
    if (list[i] == num){
      notUsed = false;
    }
  }
  if (notUsed){
    return num;
  }else{
    return GenerateRandomUnique(min,max,list);
  }
}


function shuffleArray(array) {
  for (let i = array.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [array[i], array[j]] = [array[j], array[i]];
  }
  return array;
}

function getAnswer(calculation) {
  return 1;
}

function getWrongAnswer(correctAnswer, existingWrongAnswers) {
  return 0;
}


function sleep(milliseconds) {
  var start = new Date().getTime();
  for (var i = 0; i < 1e7; i++) {
    if ((new Date().getTime() - start) > milliseconds) {
      break;
    }
  }
}

function CreateQuestions() {
  var qs = [];
  //create enough questions with the topics selected

    for (let i = 0; i < 10; i++) {//10 random numberbonds10questions
      let r = GenerateRandom(0,2);
      let qstring = "";

      if (r == 0){
        qstring = (10-i).toString() + " + " + "▢ = 10";
      }else{
        qstring = "▢ + " + (10-i).toString() + " = 10";
      }

      var questionObj = {
        topic_id: "numberbonds10only",
        question: qstring,
        answer: i,
      };
    qs.push(questionObj)
    }

  console.log("ALL QUESTIONS");
  console.log(qs);

  qs = shuffleArray(qs);

  generatedQuestions = true;
  return qs;


}

function MergeQuestions(){
  for (let i = 0; i < questions2.length; i++) {
    const quest = questions2[i];
   
    questions.push(quest);
  }
}

function Create20Questions() {
  var qs = [];
  //create enough questions with the topics selected
  let possibleNumbers = [];

  for (let i = 0; i < 20; i++) {
    possibleNumbers.push(i);
  }

    for (let i = 0; i < 10; i++) {//10 random numberbonds10questions
      let r = GenerateRandom(0,2);
      let qstring = "";

      let a = GenerateRandom(0, possibleNumbers.length);
      let b = possibleNumbers[a];
      possibleNumbers.slice(a);

      if (r == 0){
        qstring = (20-b).toString() + " + " + "▢ = 20";
      }else{
        qstring = "▢ + " + (20-b).toString() + " = 20";
      }

      var questionObj = {
        topic_id: "numberbonds20only",
        question: qstring,
        answer: b,
      };
    qs.push(questionObj)
    }

  console.log("ALL QUESTIONS");
  console.log(qs);

  qs = shuffleArray(qs);

  generatedQuestions = true;
  return qs;
}


var questions;
var questions2;
//var topics

export default function Rating({ ...props }) {

  const { state: authState } = useAuth();
  const [correctQuestions, setCorrectQuestions] = useState([]);
  const [incorrectQuestions, setIncorrectQuestions] = useState([]);
  const [score, setScore] = useState(0);
  const [combo, setCombo] = useState(0);
  const [maxCombo, setMaxCombo] = useState(0);
  const [feedback, setFeedback] = useState([]);
  const [timer, setRemainingTime] = useState(
    props.timer ? props.timer : 9999
  );

  const [submitted, setSubmitted] = useState(false);
  const [qAnswers, setQAnswers] = useState([]);
  //const [questions, setQuestions] = useState([]);
  //const examples = props.gameCalculations.map(calc =>
  //  calc.example_question.split(" ")
  //);
  const [currentQuestion, setCurrentQuestion] = useState([]);
  //topics = props.topics;
  //console.log(topics);

  useEffect(() => {
    console.log("do this once");
    console.log(qNum);
    generatedQuestions = false;
  }, []);

  if (generatedQuestions == false) {
    console.log("I am generating = " + generatedQuestions)
    let qq = CreateQuestions(questions);
    let qq2 = Create20Questions(questions2);
    //let 
    //console.log(qq);
    questions = CreateQuestions(qq)
    questions2 = Create20Questions(qq2);
    console.log(questions)
    console.log(questions2);
    qNum = 0;
    console.log("I ran");
  }
  //console.log(questions);


  async function checkResult(value, callback) {
    var isCorrect = true;
    console.log(value);
    console.log("question " + qNum);
    var dupeQuestion = {
      answer: currentQuestion.answer,
      question: currentQuestion.question,
      topic_id: currentQuestion.topic_id,
      num_asked: 0,
      num_correct: 0,
    };

    if (value) {
      //correct answer
      if (parseInt(currentQuestion.answer) === parseInt(value)) {
        dupeQuestion.num_correct = 1;
        setCorrectQuestions([...correctQuestions, dupeQuestion]);
        setScore(score + 1);

        if (combo < 99) {
          setCombo(combo + 1);
        }
        if (combo > maxCombo) {
          setMaxCombo(combo);
        }
      } //uincorrect answer
      else {
        isCorrect = false;
        dupeQuestion.num_correct = 0;
        setIncorrectQuestions([...incorrectQuestions, dupeQuestion]);
        if (combo === 0 && score >= 10) {
          setScore(score - 1);
        } else {
          setCombo(0);
        }

        let result = {
          topic_id: currentQuestion.topic_id,
          question: currentQuestion.question,
          correct: currentQuestion.answer,
          incorrect: value
        };

        setFeedback([...feedback, result]);
      }

      let qa = {
        question: currentQuestion.question,
        correct: isCorrect,
        answer: value
      }
      setQAnswers([...qAnswers, qa]);
      console.log(qAnswers);

      console.log("question " + qNum);
      qNum = qNum + 1;
      setRemainingTime(1);
      questionMode = false;
      modeText = "WAIT";
    }
  }

//check correct use effect
useEffect(() => {
  if (qAnswers.length >= 10){
    if (correctQuestions.length >= 7){
      console.log("YOU GOT 7 RIGHT PROGRESS");
      MergeQuestions();
      //then it should be next one
    }else{
      console.log("YOU DIDN'T GET 7 RIGHT GAME OVER");
      qNum = 20;
    }
  }
}, [qAnswers]);

  function NextQuestion() {
    //check props.questionsanswered and set props.questionsanswered. need to pass this variable to MTCGame so it can check if you have finished the game
    setCurrentQuestion(
      questions[qNum]
    );
    console.log(currentQuestion);
  }


  function SubmitTopics() {
    if (submitted == true) {
      return
    }
    setSubmitted(true);
    console.log(correctQuestions);
    console.log(incorrectQuestions);

    let average_ans_time = parseFloat((props.defaultTimer ? props.defaultTimer : 30) / (correctQuestions.length + incorrectQuestions.length)).toFixed(2);

    let correctByTopics = correctQuestions.reduce((byTopics, question) => {
      byTopics[question.topic_id] = byTopics[question.topic_id] || [];
      byTopics[question.topic_id].push(question);
      return byTopics;
    }, {});
    let incorrectByTopics = incorrectQuestions.reduce((byTopics, question) => {
      byTopics[question.topic_id] = byTopics[question.topic_id] || [];
      byTopics[question.topic_id].push(question);
      return byTopics;
    }, {});

    window.correctByTopics = correctByTopics;
    window.incorrectByTopics = incorrectByTopics;
    console.log(correctByTopics);
    console.log(incorrectByTopics);

    let topicstats = [...(new Set([...Object.keys(correctByTopics), ...Object.keys(incorrectByTopics)]))].map(topic_id => {
      let num_correct = correctByTopics[topic_id] ? correctByTopics[topic_id].length : 0;
      let num_incorrect = incorrectByTopics[topic_id] ? incorrectByTopics[topic_id].length : 0;
      console.log("topicID");
      console.log(topic_id);
      let tempTopicID = (topic_id);
      let tempAverageAnswerTime = parseFloat(average_ans_time);
      return {
        //topic_id: tempTopicID,
        topic_key: topic_id,
        num_correct,
        num_asked: num_correct + num_incorrect,
        average_ans_time: tempAverageAnswerTime
      }
    });
    console.log(topicstats);

    axios({
      url: `${process.env.REACT_APP_API}/submissions`,
      method: "post",
      headers: {
        "Accept": "application/json",
        "Content-Type": "application/json",
        "Authorization": `Bearer ${authState.access_token}`
      },
      data: {
        "homework_id": props.homework_id,
        "topicstats": topicstats,
        "game_id": 22, //ID equals galaxy id
        "platform": "WEB_NETLIM" + "|" + process.env.REACT_APP_VERSION_NO,
        "questionsAnswered": JSON.stringify(qAnswers)
      }
    });
  }

  // set the first question
  useEffect(() => {
    setCurrentQuestion(questions[qNum]);
  }, []);

  useEffect(() => {
    if (qNum < 20) {
      if (timer > 0) {
        var timerID = setInterval(() => decrementTimer(), 1000);
        return () => {
          clearInterval(timerID);
        };
      } else {
          NextQuestion();
          setRemainingTime(props.timer);
          modeText = "ANSWER";
          questionMode = true;
      }
    } else {
      var timerID = setInterval(() => decrementTimer(), 1000);
      console.log("endgame");
      SubmitTopics();
      return () => {
        clearInterval(timerID);
      };
    }
  }, [timer]);

  function decrementTimer() {
  console.log(timer);
    setRemainingTime(timer - 1);
  }

  function GoBack() {
    console.log("restart me")
    setCombo(0);
    setScore(0);
    setCorrectQuestions([...correctQuestions, currentQuestion]);
    setIncorrectQuestions([...incorrectQuestions, currentQuestion]);
    setRemainingTime(9);
    modeText = "ANSWER";
    questionMode = true;
    qNum = 0;
    generatedQuestions = false;
    navigate("/games/14");
  }

  return (
    <MTCGameLimited
      hidescore={true}
      correct={correctQuestions}
      incorrect={incorrectQuestions}
      score={score}
      onBack={() => {
        GoBack();
      }}
      defaultTimer={props.timer}
      restart={() => {
        console.log("restart me")
        setQAnswers([]);
        setCombo(0);
        setScore(0);
        setCorrectQuestions([]);
        setIncorrectQuestions([]);
        setRemainingTime(props.timer);
        modeText = "ANSWER";
        questionMode = true;
        qNum = 0;
        generatedQuestions = false;
        NextQuestion();
      }}
      feedback={feedback}
      questionsAnswered={qNum}
      questionCount = {qCount}
    >
      <div style={{ backgroundImage: `url(${background})`, backgroundSize: "cover", height: "400%" }} >
      {generatedQuestions ? (
        <Body>
          {questionMode && currentQuestion != undefined ? (
            <div style={{
              position: "relative",
              right: "-20%",
            }}>
              <div style={{userSelect: "none", fontSize: "100px", position: "absolute", left: "-125%", top: "1%"}}>{currentQuestion.question}</div>
                <Calculator
                  currentQuestion={currentQuestion.question}
                  onSubmitted={checkResult}
                />
            </div>
          ) : (<div></div>
            )}
          <div style={{
            height: "20%"
          }}>
            {modeText == "ANSWER" ? (
              <div>

              </div>
            ) : (
                <div style={{
                  fontSize: "50px",
                }}>
                  Question: {qNum + 1}
                </div>

              )}
          </div>
        </Body>
      ) : (<div></div>)}
      </div>
    </MTCGameLimited>
  );
}



const Body = styled.div`
  width: 100%;
  height: 100%;
  //background-image: url(${background});
  background-size: cover;
  background-position: 0px -1px;
  display: flex;
  justify-content: center;
  padding-top: 40px;
`;

const BG = styled.div`
  width: 100%;
  height: 100%;
  background-image: url(${background});
  background-size: cover;
  background-position: 0px -1px;
  //display: flex;
  //justify-content: center;
  //padding-top: 40px;
`;


const Result = styled.div`
  width: 100%;
  height: 100%;
  font-size: 5em;
  text-align: center;
  border: solid 2px #683d8c;
`;

const Combo = styled.div`
  background: #707070;
  width: 120px;
  height: 120px;
  border-radius: 75px;
  border: solid #636363 4px;
  display: flex;
  flex-direction: column;
  text-align: center;
  color: #fff;
  justify-content: center;
  font-weight: 600;
`;

